import useApiServices from './useApiServices';
import { globalURL } from './globalApi';
//
/**
 * @module superAdminServiceService
 * @returns  it return All DataSource Apis
 */

const onBoardingEkycServices = {
  GetStartUpConfig: () => useApiServices().getApi(`${globalURL}/onboarding-v1/getStartupConfig`),
  ValidateMobileNumber: (credential) =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/validateMobileNo`, credential),
  VerifyOTP: (credential) =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/verifyOTP`, credential),
  ResendOTP: (credential) =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/resendOTP`, credential),
  GetTutorial: () => useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/getTutorial`),
  GetLanguages: () =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/getLanguages`),
  GetLocationForLatLong: (credential) =>
    useApiServices().getHeaderFixCredApi(
      `${globalURL}/onboarding-v1/getLocationForLatLong`,
      credential
    ),
  GetConsents: () => useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/getConsents`),
  GetConsentFile: (credential) =>
    useApiServices().getHeaderHtmlResponseApi(
      `${globalURL}/onboarding-v1/getConsentFile`,
      credential
    ),
  GetDocList: (credential) =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/getDocList`, credential),
  GetKYCListByDoc: (credential) =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/getKYCListByDoc`, credential),
  GetOCR: (credential) =>
    useApiServices().postFormDataApi(`${globalURL}/onboarding-v1/getOCR`, credential),
  UploadImage: (headerCredential, credential) =>
    useApiServices().postFormDataApiWithHeaders(
      `${globalURL}/onboarding-v1/uploadImage`,
      headerCredential,
      credential
    ),
  GetRetakes: (credential) =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/getRetakes`, credential),
  FaceMatch: (credential) =>
    useApiServices().postFormDataApi(`${globalURL}/onboarding-v1/faceMatch`, credential),
  GetFileFromUrl: (credential) =>
    useApiServices().getHeaderImgBlobApi(`${globalURL}/onboarding-v1/getFileFromUrl`, credential),
  SaveUserInfo: (hdrCredential, credential) =>
    useApiServices().postHeaderFixCredApi(
      `${globalURL}/onboarding-v1/saveUserInfo`,
      hdrCredential,
      credential
    ),
  GetFaq: (credential) =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/getFaq`, credential),
  GetKYCStatus: (credential) =>
    useApiServices().getHeaderFixCredApi(`${globalURL}/onboarding-v1/getKYCStatus`, credential),
  GetBookedSlotDetails: (hdrCredential) =>
    useApiServices().getApiWithHeaders(
      `${globalURL}/onboarding-v1/getBookedSlotDetails`,
      hdrCredential
    ),
  ScheduleDetails: (hdrCredential) =>
    useApiServices().postApiWithHeaders(
      `${globalURL}/onboarding-v1/scheduleDetails`,
      hdrCredential
    ),
  SetFCMToken: (hdrCredential) =>
    useApiServices().postApiWithHeaders(`${globalURL}/onboarding-v1/setFCMToken`, hdrCredential),

  BookAgentSlot: (hdrCredential) =>
    useApiServices().postApiWithHeaders(`${globalURL}/onboarding-v1/bookAgentSlot`, hdrCredential),
  GenerateTokenForEKYC: (hdrCredential) =>
    useApiServices().postHeaderFixCredApi(
      `${globalURL}/onboarding-v1/generateTokenForEKYC`,
      hdrCredential
    ),
  AadharOTPSend: (hdrCredential) =>
    useApiServices().postApiWithHeaders(`${globalURL}/onboarding-v1/aadharOTPSend`, hdrCredential),
  AadharVerification: (hdrCredential) =>
    useApiServices().postApiWithHeaders(
      `${globalURL}/onboarding-v1/aadharVerification`,
      hdrCredential
    ),
  PanVerification: (hdrCredential) =>
    useApiServices().postApiWithHeaders(
      `${globalURL}/onboarding-v1/panVerification`,
      hdrCredential
    ),
  GetNearByShops: (hdrCredential) =>
    useApiServices().postApiWithHeaders(`${globalURL}/onboarding-v1/getNearByShops`, hdrCredential)
  // UploadEKYCScreenShots: (hdrCredential, credential) =>
  //   useApiServices().postApiWithHeaders(
  //     `${globalURL}/onboarding-v1/uploadEKYCScreenShots`,
  //     hdrCredential,
  //     credential
  //   )

  // GetStartUpConfig: () => useApiServices().getApi(`${globalSRP}/getStartupConfig`),
  // GetTutorial: () => useApiServices().getApi(`${globalSRP}/getTutorial`),
  // GetReTakes: () => useApiServices().getApi(`${globalSRP}/getRetakes`),
  // GetLanguages: () => useApiServices().getApi(`${globalSRP}/getLanguages`),
  // GetFaq: () => useApiServices().getApi(`${globalSRP}/getFaq`),
  // GetConsents: () => useApiServices().getApi(`${globalSRP}/getConsents`),
  // GetNationality: (credential) =>
  //   useApiServices().getHeaderApi(`${globalSRP}/GetNationality`, credential),
  // GetConsentPDF: () =>
  //   useApiServices().getApi(`https://api.ntportal.com/dev/journey/getConsentPDF`),
  // GetFileFromUrl: (credential) =>
  //   useApiServices().getHeaderApi(`${globalSRP}/getFileFromUrl`, credential),
  // GetConsentFile: () => `${globalSRP}/getConsentFile`,
  // FetchSalutationAndGender: () => useApiServices().getApi(`${globalSRP}/fetchSalutationAndGender`),
  // FetchLookupAddress: () => useApiServices().getApi(`${globalSRP}/fetchLookupAddress`),
  // FileName: (fileName) => useApiServices().getApi(`${globalSRP}/file/${fileName}`),
  // GetOCR: (credential, path) =>
  //   useApiServices().postFormDataApi(`${globalSRP}/getOCR${path}`, credential),
  // GetPuk: (credential) => useApiServices().postApi(`${globalSRP}/getPuk`, credential),
  // FaceMatch: (credential, path) =>
  //   useApiServices().postFormDataApi(`${globalSRP}/faceMatch${path}`, credential),
  // // thai language list of address
  // GetListOfProvinces: (fileName) => useApiServices().getApi(`${globalSRP}/GetListOfProvinces`),
  // GetListOfDistrict: (credential) =>
  //   useApiServices().postApi(`${globalSRP}/GetListOfDistrict`, credential),
  // GetListOfSubDistrict: (credential) =>
  //   useApiServices().postApi(`${globalSRP}/GetListOfSubDistrict`, credential),
  // GetZipCodes: (credential) => useApiServices().postApi(`${globalSRP}/GetZipCodes`, credential),
  // // apis for address in english value
  // GetListOfProvincesManual: (fileName) =>
  //   useApiServices().getApi(`${globalSRP}/GetListOfProvincesManual`),
  // GetListOfDistrictManual: (credential) =>
  //   useApiServices().postApi(`${globalSRP}/GetListOfDistrictManual`, credential),
  // GetListOfSubDistrictManual: (credential) =>
  //   useApiServices().postApi(`${globalSRP}/GetListOfSubDistrictManual`, credential),
  // GetZipCodesManual: (credential) =>
  //   useApiServices().postApi(`${globalSRP}/GetZipCodesManual`, credential),

  // SaveUserInfo: (credential) => useApiServices().postApi(`${globalSRP}/saveUserInfo`, credential),
  // SaveMobileRelatedData: (credential) =>
  //   useApiServices().postApi(`${globalSRP}/saveMobileRelatedData`, credential),
  // GetNearByShops: (credential) =>
  //   useApiServices().postHeaderData(`${globalSRP}/getNearByShops`, credential),
  // UploadImage: (credential, query) =>
  //   useApiServices().postFormDataApi(`${globalSRP}/uploadImage?${query}`, credential),
  // OrderStatus: (credential) =>
  //   useApiServices().postApiWithHeaders(`${globalSRP}/orderStatus`, credential),
  // GetLocationForLatLong: (credential) =>
  //   useApiServices().getHeaderApi(`${globalSRP}/getLocationForLatLong`, credential),
  // SetFCMToken: (credential) =>
  //   useApiServices().postHeaderData(`${globalSRP}/setFCMToken`, credential),
  // SendNotification: (credential) =>
  //   useApiServices().postHeaderData(`${globalSRP}/sendNotification`, credential)
};

export default onBoardingEkycServices;
